/* src/app/core/card-preauth/card-preauth-toast.component.scss */
:host {
  --sub-warn: #F5A623;
  --sub-warn-text: #FFC25C;
  --sub-danger: #FF6B6B;
  --sub-accent: var(--highlight_primary, #2569B8);
}
.sub-toast {
  position: fixed;
  right: 56px;
  bottom: 40px;
  z-index: 1000;
  width: 400px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
  padding: 20px 20px 16px;
  border-radius: 14px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(22, 24, 32, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55);
}
.sub-toast__head {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sub-toast__warn {
  color: var(--sub-warn);
}
.sub-toast__warn path {
  stroke: var(--sub-warn);
  fill: none;
}
.sub-toast__eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--sub-danger);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.sub-toast__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sub-danger);
}
.sub-toast--promo {
  border-color: rgba(37, 105, 184, 0.55);
  border-color: color-mix(in srgb, var(--sub-accent) 55%, transparent);
}
.sub-toast__eyebrow--promo {
  color: var(--sub-accent);
}
.sub-toast__gift {
  flex: none;
}
.sub-toast__gift path,
.sub-toast__gift rect {
  stroke: currentColor;
  fill: none;
}
.sub-toast h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}
.sub-toast p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
}
.sub-toast__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
}
.sub-toast__actions button {
  height: 44px;
  padding: 0 20px;
  border: 0;
  border-radius: 999px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}
.sub-toast .btn-ghost {
  background: transparent;
  color: #fff;
  font-weight: 600;
}
.sub-toast .btn-primary {
  background: var(--sub-accent);
  color: #fff;
  font-weight: 700;
}
@media (max-width: 600px) {
  .sub-toast {
    right: 16px;
    left: 16px;
    bottom: 16px;
    width: auto;
  }
}
/*# sourceMappingURL=card-preauth-toast.component.css.map */
